import React from 'react'
import TimeTable from '../../DCM/components/Time-table'

export default function LiveMain() {
  return (
    <div>
      <TimeTable />
    </div>
  )
}
